/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BuiltInUserResponse,
} from '../models/index';
import {
    BuiltInUserResponseFromJSON,
    BuiltInUserResponseToJSON,
} from '../models/index';

export interface CheckBuiltInUserRequest {
    userEmail: string;
    sessionId?: string;
}

export interface GetBuiltInUserRequest {
    userEmail: string;
    sessionId?: string;
}

export interface GetBuiltInUsersRequest {
    sessionId?: string;
}

/**
 * BuiltInUsersApi - interface
 * 
 * @export
 * @interface BuiltInUsersApiInterface
 */
export interface BuiltInUsersApiInterface {
    /**
     * Check if a specific user email is configured as a built-in user
     * @summary Check if user is built-in
     * @param {string} userEmail 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuiltInUsersApiInterface
     */
    checkBuiltInUserRaw(requestParameters: CheckBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>>;

    /**
     * Check if a specific user email is configured as a built-in user
     * Check if user is built-in
     */
    checkBuiltInUser(requestParameters: CheckBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse>;

    /**
     * Retrieve configuration for a specific built-in user
     * @summary Get specific built-in user definition
     * @param {string} userEmail 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuiltInUsersApiInterface
     */
    getBuiltInUserRaw(requestParameters: GetBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>>;

    /**
     * Retrieve configuration for a specific built-in user
     * Get specific built-in user definition
     */
    getBuiltInUser(requestParameters: GetBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse>;

    /**
     * Retrieve all configured built-in user definitions
     * @summary Get all built-in user definitions
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuiltInUsersApiInterface
     */
    getBuiltInUsersRaw(requestParameters: GetBuiltInUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>>;

    /**
     * Retrieve all configured built-in user definitions
     * Get all built-in user definitions
     */
    getBuiltInUsers(requestParameters: GetBuiltInUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse>;

}

/**
 * 
 */
export class BuiltInUsersApi extends runtime.BaseAPI implements BuiltInUsersApiInterface {

    /**
     * Check if a specific user email is configured as a built-in user
     * Check if user is built-in
     */
    async checkBuiltInUserRaw(requestParameters: CheckBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>> {
        if (requestParameters['userEmail'] == null) {
            throw new runtime.RequiredError(
                'userEmail',
                'Required parameter "userEmail" was null or undefined when calling checkBuiltInUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/built-in-users/check/{userEmail}`;
        urlPath = urlPath.replace(`{${"userEmail"}}`, encodeURIComponent(String(requestParameters['userEmail'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuiltInUserResponseFromJSON(jsonValue));
    }

    /**
     * Check if a specific user email is configured as a built-in user
     * Check if user is built-in
     */
    async checkBuiltInUser(requestParameters: CheckBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse> {
        const response = await this.checkBuiltInUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve configuration for a specific built-in user
     * Get specific built-in user definition
     */
    async getBuiltInUserRaw(requestParameters: GetBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>> {
        if (requestParameters['userEmail'] == null) {
            throw new runtime.RequiredError(
                'userEmail',
                'Required parameter "userEmail" was null or undefined when calling getBuiltInUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/built-in-users/{userEmail}`;
        urlPath = urlPath.replace(`{${"userEmail"}}`, encodeURIComponent(String(requestParameters['userEmail'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuiltInUserResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve configuration for a specific built-in user
     * Get specific built-in user definition
     */
    async getBuiltInUser(requestParameters: GetBuiltInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse> {
        const response = await this.getBuiltInUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all configured built-in user definitions
     * Get all built-in user definitions
     */
    async getBuiltInUsersRaw(requestParameters: GetBuiltInUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuiltInUserResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/built-in-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuiltInUserResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all configured built-in user definitions
     * Get all built-in user definitions
     */
    async getBuiltInUsers(requestParameters: GetBuiltInUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuiltInUserResponse> {
        const response = await this.getBuiltInUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
